import request from "@/utils/request/index";

export enum Api {
  GET_SHARELIST = "itemShare/shareItem",
  GET_USER = "itemShare/getUser",
  SAVEMEMBER = "itemShare/saveMember",
  SAVESHAREURL = "itemShare/saveShareUrl",
  SHAREINFO = "share/getShareItemParam",
  ENTER = "itemShare/enter",
}

// 获取授权信息（点击授权调用）
export const shareListInfo = (data?: any) =>
  request.get(Api.GET_SHARELIST, data);

// 根据手机号码获取用户
export const getUserList = (data?: any) =>
  request.get(Api.GET_USER, data);

// 保存成员列表
export const saveUser = (data?: any) =>
  request.post(Api.SAVEMEMBER, data);

// 授权分享链接信息保存
export const saveShareUrl = (data?: any) =>
  request.post(Api.SAVESHAREURL, data);

// 获取授权信息（分享链接跳转后请求）
export const getShareInfo = (data?: any) =>
  request.get(Api.SHAREINFO+'/?id='+data);

// 立即加入
export const shareEnter = (data?: any) =>
  request.post(Api.ENTER+'/?'+data);


  

